import React from 'react';
import ScheduleInboundActionButton from '../Components/ScheduleInbound/ScheduleInboundActionButton';
import { ACTIONS } from '../Constants';

export const getNotificationAction = ({ actionType, actionData, handleAction }) => {
  switch (actionType) {
    case ACTIONS.SCHEDULE_INBOUND:
      return (
        <ScheduleInboundActionButton actionType={actionType} actionData={actionData} handleAction={handleAction} />
      );
    default:
      return null;
  }
};

export const filterConnectedWarehouses = (w) =>
  w.connection_status === 'success' && w.write_enabled === true && w.wms !== 'store';
